/**
 * src/components/Router.js
 * 
 * Componente router que maneja la navegación
 */

import {
    effect
} from '@core/signal.js'
import {
    define,
    c,
    render
} from '@components/Component.js'
import {
    currentPath
} from '@features/router/router.state.js'
import {
    matchRoute
} from '@features/router/router.utils.js'

define('Router', () => {
    const container = document.createElement('div')
    container.className = 'router-container'

    let currentRoute = null
    let currentRenderer = null

    effect(() => {
        const path = currentPath.get()
        const routeMatch = matchRoute(path)

        // Al cambiar de ruta, siempre empezar desde arriba de la página
        // (evita que el directorio/promos aparezcan a media página).
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' })

        if (routeMatch) {
            if (currentRoute && currentRoute.component === routeMatch.component) {
                // Si es el mismo componente, solo actualizamos las props
                if (currentRenderer) {
                    currentRenderer.update({
                        params: routeMatch.params
                    })
                }
            } else {
                // Si es un componente diferente, limpiamos el anterior y renderizamos el nuevo
                if (currentRenderer) {
                    currentRenderer.cleanup()
                }

                currentRenderer = render(
                    (props) => c(routeMatch.component, props),
                    container, {
                        params: routeMatch.params
                    }
                )

                currentRoute = routeMatch
            }
        } else {
            if (currentRenderer) {
                currentRenderer.cleanup()
            }
            currentRenderer = render(
                (props) => c('UnderConstructionPage', props),
                container, {}
            )
            currentRoute = null
        }
    })

    return container
})